<template>
  <div class="home-admin">
    <div class="home-top">
      <div class="right card">
        <div class="headline">
          <div>概况</div>
        </div>
        <div class="rigthData">
          <div>
            <div>商户数量</div>
            <div><span>{{generalSituation.commercialTenantNum}}</span><br><span class="grey">{{generalSituation.allCommercialTenantNum}}</span></div>
            <div class='font16'><span class="green">生效</span><br><span class="grey">全部</span></div>
          </div>
          <div>
            <div>仓库数量</div>
            <div><span>{{generalSituation.warehouseNum}}</span><br><span class="grey">{{generalSituation.allWarehouseNum}}</span></div>
            <div class='font16'><span class="red">有效</span><br><span class="grey">全部</span></div>
          </div>
          <div>
            <div>供应商数量</div>
            <div><span>{{generalSituation.supplierNum}}</span><br><span class="grey">{{generalSituation.allSupplierNum}}</span></div>
            <div class='font16'><span class="red">有效</span><br><span class="grey">全部</span></div>
          </div>
        </div>
        <div class="ylCount">
          <div>
            <div class="font34">{{generalSituation.allExt}}</div>
            <div>总库存(件)</div>
          </div>
          <div>
            <div class="font34">{{generalSituation.allValue}}</div>
            <div>总货值(元)</div>
          </div>
        </div>
      </div>
      <div class="left">
        <div class="top card">
         <div class="headline">今日数据</div>
         <div class="todayData">
           <div>
             <div class="num">{{todayData.inputNum}}</div>
             <div class="tip">入库任务</div>
           </div>
           <div>
             <div class="num">{{todayData.outputNum}}</div>
             <div class="tip">出库任务</div>
           </div>
           <div>
             <div class="num">{{todayData.shelvesNum}}</div>
             <div class="tip">上架单</div>
           </div>
           <div>
             <div class="num">{{todayData.inventoryNum}}</div>
             <div class="tip">盘点计划</div>
           </div>
           <div>
             <div class="num">{{todayData.moveNum}}</div>
             <div class="tip">快速移库</div>
           </div>
         </div>
        </div>
        <div class="bottom">
          <div class="card">
            <span class="headline">本月账单</span>
            <div class="totalmoney"><span>共</span><span class="bold">{{totalmoney}}</span><span>元</span></div>
            <div id="monthBill">
            </div>
          </div>
          <div class="card">
            <span class="headline">登录次数</span>
            <div class="avgLoginNum"><span>平均</span><span class="bold">{{avgLoginNum}}</span><span>次/日</span></div>
            <div id="loginNum">
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="home-bottom card">
      <div>
        <div class="headline">全平台出货量统计</div>
        <div class="seach">
           <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="changeTime" :picker-options="pickerOptions" :clearable="false">
          </el-date-picker>
          <div class="image">
            <img src="@/assets/images/home/shipment-1.png" @click="changeChart(true)">
            <img src="@/assets/images/home/shipment-2.png" @click="changeChart(false)">
          </div>
        </div>
      </div>
      <div class="chart">
        <div id="shipmentChart"></div>
        <div id="pieChart"></div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { GETSAASHOMEPAGETOP, GETSAASHOMEPAGEBELOW } from '@/store/home/types.js'
let _self
export default {
  data () {
    return {
      shipmentChart: null,
      pieChart: null,
      loginNum: null,
      monthBill: null,
      date: null,
      show: true,
      generalSituation: {},
      todayData: {},
      allOutputStatistics: {},
      avgLoginNum: 0,
      totalmoney: 0,
      pickerOptions: {
        disabledDate (time) {
          let curDate = (new Date()).getTime()
          let a = 366 * 24 * 3600 * 1000
          let b = curDate - a
          let c = curDate - 1 * 24 * 3600 * 1000
          return time.getTime() > c || time.getTime() < b
        }
      }

    }
  },
  beforeDestroy () {
    if (!this.shipmentChart || !this.pieChart) {
      return
    }
    this.shipmentChart.dispose()
    this.pieChart.dispose()
    this.barChart = null
    this.pieChart = null
  },
  mounted () {
    _self = this
    let end = new Date()
    let start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
    this.date = [this.dateFormat('YYYY-mm-dd', start), this.dateFormat('YYYY-mm-dd', end)]
    this.getData()
    this.getBelow()
  },
  methods: {
    // 获取数据
    getData () {
      this.$store.dispatch(GETSAASHOMEPAGETOP, {}).then(res => {
        _self.generalSituation = res.generalSituation
        _self.todayData = res.todayData
        _self.avgLoginNum = res.LoginNum.avgLoginNum
        _self.totalmoney = res.monthBill.totalmoney
        _self.setLoginChart(res.LoginNum)
        _self.setMonthBillChart(res.monthBill)
      })
    },
    // 登录折线图
    setLoginChart (data) {
      let loginNum = document.getElementById('loginNum')
      _self.loginNum = echarts.init(loginNum)
      _self.loginNum.setOption({
        xAxis: {
          type: 'category',
          splitLine: {show: false},
          axisTick: {show: false},
          axisLabel: {show: false},
          axisLine: {
            lineStyle: {
              color: '#D3D3D3'
            }
          },
          data: data.yAxis
        },
        yAxis: {
          splitLine: {show: false}, // 坐标轴在 grid 区域中的分隔线设置
          axisTick: {show: false}, // 坐标轴刻度相关设置
          axisLabel: {show: false}, // 坐标轴刻度标签的相关设置
          axisLine: { // 坐标轴轴线相关设置
            lineStyle: {
              color: '#D3D3D3'
            }
          },
          type: 'value'
        },
        series: [
          {
            data: data.series,
            type: 'line',
            smooth: true,
            symbol: 'none'
          }
        ],
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '6%',
          left: '2%',
          right: '0%',
          bottom: '20%',
          containLabel: true
        },
        itemStyle: {
          color: '#89A2FF'
        }
      })
      window.addEventListener('resize', function () {
        _self.loginNum.resize()
      })
    },
    // 本月账单面积图
    setMonthBillChart (data) {
      let monthBill = document.getElementById('monthBill')
      _self.monthBill = echarts.init(monthBill)
      _self.monthBill.setOption({
        xAxis: {
          type: 'category',
          show: false,
          data: data.yAxis
        },
        yAxis: {
          show: false,
          type: 'value'
        },
        series: [
          {
            data: data.series,
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {
              color: '#5B78FF',
              opacity: 1
            }
          }
        ],
        tooltip: {
          trigger: 'axis'
        },
        itemStyle: {
          color: '#5B78FF',
          opacity: 1
        },
        grid: {
          top: '6%',
          left: '3%',
          right: '4%',
          bottom: '20%'
        }
      })
      window.addEventListener('resize', function () {
        _self.monthBill.resize()
      })
    },
    getBelow () {
      let params = {
        beginTime: this.date[0],
        endTime: this.date[1]
      }
      let _self = this
      this.$store.dispatch(GETSAASHOMEPAGEBELOW, params).then(res => {
        _self.allOutputStatistics = res.allOutputStatistics
        _self.initPieChart(res.platformShipmentProportion)
        _self.initBarChart(res.allOutputStatistics)
      })
    },
    // 饼图
    initPieChart (data) {
      let pieChart = document.getElementById('pieChart')
      this.pieChart = echarts.init(pieChart)
      this.pieChart.setOption({
        series: [
          {
            type: 'pie',
            radius: '50%',
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
              normal: {
                color: function (colors) {
                  var colorList = [
                    '#5775CE', '#91CC75', '#FAC858', '#EE6666',
                    '#73C0DE', '#DC2626', '#84CC16', '#0EA5E9', '#EF4444', '#A3E635', '#60A5FA', '#FECACA', '#D9F99D', '#BAE6FD', '#EA580C', '#22C55E',
                    '#D946EF', '#FB923C', '#4ADE80', '#E879F9', '#FED7AA', '#86EFAC', '#F5D0FE', '#F59E0B', '#14B8A6', '#475569', '#FBBF24', '#2DD4BF',
                    '#94A3B8', '#FDE68A', '#5EEAD4', '#E2E8F0'
                  ]
                  return colorList[colors.dataIndex]
                }
              }
            },
            label: {
              show: true,
              color: '#1A1A1A',
              formatter: '{b}:{d}%',
              fontSize: 14
            },
            avoidLabelOverlap: true,
            data: data
          }
        ]
      })
      window.addEventListener('resize', function () {
        _self.pieChart.resize()
      })
    },
    // 柱状图
    initBarChart (data) {
      let shipmentChart = document.getElementById('shipmentChart')
      this.shipmentChart = echarts.init(shipmentChart)
      this.shipmentChart.setOption({
        color: '#5B78FF',
        grid: {
          top: '10%',
          left: '3%',
          right: '12%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.yAxis,
          axisLine: {
            lineStyle: {
              color: '#9F9F9F'
            }
          },
          axisTick: {show: false}
        },
        yAxis: {
          type: 'value',
          axisTick: {show: false},
          axisLine: {show: false},
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#999'
            }
          },
          axisLabel: {
            color: '#999',
            margin: 12
          }

        },
        series: [
          {
            data: data.series,
            type: 'bar',
            smooth: true,
            symbol: 'none',
            barMaxWidth: 28
          }
        ],
        tooltip: {
          trigger: 'axis'
        }
      })
      window.addEventListener('resize', function () {
        _self.shipmentChart.resize()
      })
    },
    // 折线图
    initLineChart (data) {
      let shipmentChart = document.getElementById('shipmentChart')
      this.shipmentChart = echarts.init(shipmentChart)
      this.shipmentChart.setOption({
        color: '#5B78FF',
        grid: {
          top: '10%',
          left: '3%',
          right: '12%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.yAxis
        },
        yAxis: {
          type: 'value'

        },
        series: [
          {
            data: data.series,
            type: 'line',
            smooth: true,
            symbol: 'none'
          }
        ],
        tooltip: {
          trigger: 'axis'
        }
      })
      window.addEventListener('resize', function () {
        _self.shipmentChart.resize()
      })
    },
    changeChart (flag) {
      this.show = flag
      if (flag) {
        this.initBarChart(this.allOutputStatistics)
      } else {
        this.initLineChart(this.allOutputStatistics)
      }
    },
    changeTime (e) {
      this.getBelow()
    },
    dateFormat (fmt, time) {
      let ret
      const opt = {
        'Y+': time.getFullYear().toString(), // 年
        'm+': (time.getMonth() + 1).toString(), // 月
        'd+': time.getDate().toString(), // 日
        'H+': time.getHours().toString(), // 时
        'M+': time.getMinutes().toString(), // 分
        'S+': time.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
      };
      return fmt
    }
  }

}
</script>
<style scoped>
/**左边 */
.home-admin{
  width: 100%;
  height: 100%;
}
.home-top{
  height: 420px;
  display: flex;
  margin-bottom:12px;
  box-sizing: border-box;
}
 .card{
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-sizing: border-box;
}
.home-top .left{
  width: 65%;
  height: 100%;
  margin-left:12px;
  flex-grow: 1;
}
.home-top .right{
  width: 34%;
  height: 100%;
}
.home-top .right .rigthData{
  font-size: 18px;
  font-weight: bold;
  color: #1A1A1A;
  text-align: center;
  margin: 30px 12px;
}
.home-top .right .ylCount{
  margin: 20px 9px 0;
  background: linear-gradient(96deg, #7D6FFF 0%, #6790FA 100%);
  border-radius: 4px;
  height: 25%;
  color:#FFFFFF;
  display: flex;
  font-size: 14px;
  box-sizing: border-box;
  padding: 20px;
  justify-content:space-around;
}

.font34{
  font-size: 34px;
}
.home-top .right .rigthData>div{
  display: flex;
  align-items:left;
  justify-content:space-around;
  margin: 25px 0;
  text-align: left;
}
.home-top .right .rigthData>div>div:nth-child(3){
  flex-grow: 1;
}
.home-top .right .rigthData>div div:nth-child(1){
  font-size: 20px;
  color: #1A1A1A;
  line-height: 45px;
  width: 48%;
}
.home-top .right .rigthData>div div:nth-child(3){
  text-align: right;
}
.home-top .left .top {
  height: 180px;
}
.home-top .left .top >div:nth-child(1){
  height: 19%;
  margin-bottom: 12px;
}
.home-top .left .top .todayData{
  height: 70%;
  display: flex;
  justify-content:space-around;
}
.home-top .left .top .todayData>div{
  width:17%;
  height: 100%;
  background: #EBECEE;
  border-radius: 6px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items:center;
  align-content: center;
}
.home-top .left .top .todayData>div>div{
  width:100%;
}
.home-top .left .top .todayData>div .num{
  font-size: 40px;
}
.home-top .left .top .todayData>div .tip{
  font-size: 14px;
  color:#999999;
}
.home-top .left .top .todayData>div:nth-child(1){
  color:#fff ;
  background-image: url(../../assets/images/home/today-data-bg1.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.home-top .left .top .todayData>div:nth-child(2){
  color: #fff ;
  background-image: url(../../assets/images/home/today-data-bg2.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.home-top .left .top .todayData>div:nth-child(1) .tip,.home-top .left .top .todayData>div:nth-child(2) .tip{
  color:#fff;
}
.home-top .left .bottom{
  display: flex;
  height: 228px;
  margin-top:12px ;
}
.home-top .left .bottom .card{
  width:49%;
}
.home-top .left .bottom .card:nth-child(1){
  width:50%;
  margin-right:1% ;
}
.headline{
  font-size: 22px;
  font-weight: bold;
  color: #1A1A1A;
}
.grey{
  color: #CCCCCC;
}
.green{
  color: #0CC838;
}
.red{
  color: #E41601;
}
.font16{
  font-size: 16px;
  font-weight: 500;
}
#loginNum,#monthBill{
  width: 90%;
  height: 80%;
  box-sizing: border-box;
}
.totalmoney,.avgLoginNum{
  font-size: 20px;
  color: #1A1A1A;
  font-weight: 500;
  text-align: right;
}
.totalmoney .bold,.avgLoginNum .bold{
  font-size: 36px;
}
.seach{
  display: flex;
  align-items:flex-end;
}
.seach .image{
  margin-left:20px ;
}
.seach img{
  width:30px;
  height: 30px;
  cursor: pointer;
  display: inline-block;
  margin-right:10px ;
}
.home-bottom{
  width:100%;
}
.home-bottom > div:nth-child(1){
  display: flex;
  justify-content: space-between;
}
.chart{
  width:100%;
  height: 400px;
  display: flex;
}
#shipmentChart{
  width:68%;
  height: 100%;
}
#pieChart{
  width:32%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/page/home/Home-admin.vue